import React from 'react';
import { Logger } from '../../utils';
import useVideoContext from '../../hooks/useVideoContext';

export default function EndCallButton(props) {
    const { room, isSharingScreen, toggleScreenShare, removeLocalAudioTrack, removeLocalVideoTrack } = useVideoContext();
    const hangupBtnClick = () => {
        Logger("UI.Twilio.Room.HangUp.Clicked", new Date());
        props.setIsEndCall(true);
        if (isSharingScreen) {
            toggleScreenShare();
        }
        removeLocalAudioTrack();
        removeLocalVideoTrack();
        room.disconnect();
        window.twilioRoom = null;
    };
    return (
        <React.Fragment>
            <button type="button" className="btn" onClick={hangupBtnClick} id="hang-up"><span className="icon-hang-up" /></button>           
        </React.Fragment>
    );
}
